'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPubSubClient = exports.getAsyncPubSubClient = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getters = require('conversations-async-data/async-data/operators/getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAsyncPubSubClient = exports.getAsyncPubSubClient = (0, _get2.default)('pubSubClient');

var getPubSubClient = exports.getPubSubClient = function getPubSubClient(state) {
  return (0, _getters.getData)(getAsyncPubSubClient(state));
};